import { SortOrder, generateBomOptionGalleryName, sortBasedOnRecentBomOptionsList } from '../bom-options/utils';
import { getBomPreviewColorCode, getWhetherItemHasClickableColorSwatches } from '../../main/selectors';

import { MediaType } from './constants';
import { createSelector } from 'reselect';
import { scene7StockImageMode } from '../../utils/constants';

const imageAssetMainElement = 'PromotionalStore/i?src=is{PromotionalStore/';
const imageAssetTemplateElements = [imageAssetMainElement, '}&$ProductDetail_F$'];
const imageUrlMainElement = 'https://images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/';
const imageUrlTemplateElements = [imageUrlMainElement, '}&$ProductDetail_D$'];
const thumbnailUrlTemplateElements = [imageUrlMainElement, '}&$ProductDetail_T$'];

export const getBaseProductGalleryItems = createSelector(
  (state) => state.specs,
  (specs) => {
    const { galleryMainStockImageExistence, imageCount, itemId, mediaGalleryItems, twinItemId } = specs;

    const galleryItems = Array.from({ length: imageCount + 1 }, (_, index) => {
      let name = `product_${
        galleryMainStockImageExistence === scene7StockImageMode.TwinItemExist && !!twinItemId ? twinItemId : itemId
      }`;
      if (index > 0) name += `_${index}`;
      return {
        asset: imageAssetTemplateElements.join(name),
        imageUrl: imageUrlTemplateElements.join(name),
        mediaType: MediaType.image,
        name,
        thumbnailUrl: thumbnailUrlTemplateElements.join(name),
      };
    });

    mediaGalleryItems.forEach((item) => {
      const { media, rank, thumbnail } = item;
      const position = rank < 0 || rank > galleryItems.length ? galleryItems.length : rank;
      galleryItems.splice(position, 0, {
        asset: media,
        imageUrl: '',
        mediaType: MediaType.video,
        name: `video_${rank}`,
        thumbnailUrl: thumbnail,
      });
    });

    return galleryItems;
  }
);

export const getProductDetailsInterfaceSettings = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceSettings
);

export const getBomOptionsBackup = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceBuffer.bomOptionsBackup
);

export const getCurrentBomOption = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceBuffer.currentBomOption
);

export const getCurrentEditedBomOption = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceBuffer.currentEditedBomOption
);

export const getCurrentGalleryItem = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceBuffer.currentGalleryItem
);

export const getRecentBomOptionsList = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi.productDetailsInterfaceBuffer.recentBomOptions
);

export const getMostRecentlySelectedBomOption = createSelector(
  getRecentBomOptionsList,
  (state) => state.uniqueOptions,
  (_, code) => code,
  (recentBomOptions, uniqueOptions, code) => {
    if (recentBomOptions.length > 0) {
      return recentBomOptions[recentBomOptions.length - 1];
    }

    const selectedOptions = (uniqueOptions[code] || []).filter((option) => option.isSelected);
    return selectedOptions.length > 0 ? selectedOptions[selectedOptions.length - 1] : null;
  }
);

export const getSelectedBomOptionsGalleryItems = createSelector(
  getWhetherItemHasClickableColorSwatches,
  getBomPreviewColorCode,
  getRecentBomOptionsList,
  (state) => state.specs,
  (state) => state.uniqueOptions,
  (hasClickableColorSwatches, colorCodes, recentBomOptionsList, specs, uniqueOptions) => {
    const colorChangeable = hasClickableColorSwatches && !!colorCodes && colorCodes.length === 1;
    return colorChangeable
      ? sortBasedOnRecentBomOptionsList(
          uniqueOptions[colorCodes[0]].filter((option) => option.isSelected),
          recentBomOptionsList,
          SortOrder.Desc
        ).map((option) => {
          const name = generateBomOptionGalleryName(option, specs);
          return {
            asset: imageAssetTemplateElements.join(name),
            imageUrl: imageUrlTemplateElements.join(name),
            mediaType: MediaType.image,
            name,
            thumbnailUrl: thumbnailUrlTemplateElements.join(name),
          };
        })
      : [];
  }
);

export const getProductGalleryItems = createSelector(
  getSelectedBomOptionsGalleryItems,
  getBaseProductGalleryItems,
  (selectedBomOptionsGalleryItems, baseProductGalleryItems) => {
    const galleryItems = selectedBomOptionsGalleryItems.concat(baseProductGalleryItems);

    console.log('Invoke getProductGalleryItems():');
    console.log(galleryItems);
    return galleryItems;
  }
);
